import { returnErrors } from './errorAction';
import { GET_CANDIDATES_SUCCESS, UPLOAD_CANDIDATES_SUCCESS, GET_CANDIDATE_PROFILE_SUCCESS, SET_VOICE_SESSION_DATA, CANDIDATE_LOADING, SET_ASSESSMENT_INVITE_DETAILS, CLEAR_CANDIDATE_LIST, SET_VIDEO_SESSION_DATA, GET_PREQUALIFYING_REPORT, GET_LIST_CANDIDATES_SUCCESS, CLEAR_LIST_CANDIDATES } from '../Types/types';
import { getJobApiCall, postJobApiCall, deleteJobApiCall, putJobApiCall, getJobApiBlobCall, patchJobApiCall } from '../../utils/jobRequest';
import { getApiCall, handle403Logout, postApiCall } from '../../utils/request';

export const fetchCandidatesByJobId = (jobId, queryParams = "") => async (dispatch) => {
  try {
    let baseUrl = `jobs/${jobId}/job-candidates`;
    const connector = queryParams ? "&" : "";
    const finalQuery = `${queryParams}${connector}`;
    const url = `${baseUrl}?${finalQuery}`;
    const response = await getJobApiCall(url);
    if (response?.status === 200) {
      dispatch({ type: GET_CANDIDATES_SUCCESS, payload: { data: response.data.data || [], pagination: response.data.pagination || { total: 0, page: 1, page_size: 10 }, } });
    } else {
      returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    dispatch({ type: GET_CANDIDATES_SUCCESS, payload: [] });
    returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
  }
};

// Upload CSV
export const uploadCsvCandidateFile = (jobId, file) => async (dispatch) => {
  try {
    const formData = new FormData();
    // formData.append("file", file);
    if (!(file instanceof File)) {
      console.error("Invalid file type: ", file);
      return { success: false, message: "Invalid file format." };
    }

    formData.append("file", file, file.name);

    const response = await postJobApiCall(
      `jobs/${jobId}/job-candidates/upload-csv`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    if (response?.status === 200) {
      dispatch({ type: UPLOAD_CANDIDATES_SUCCESS, payload: response.data.message });
      return { success: true, message: response.data.message };
    } else {
      const message = response?.data?.detail || response?.data?.message || "Upload failed";
      return { success: false, message };
    }
  } catch (error) {
    handle403Logout(error);
    const message =
      error?.response?.data?.detail ||
      error?.response?.data?.message ||
      error?.message ||
      "Upload failed";
    return { success: false, message };
  }
};


// Upload Resume (PDF)
export const uploadPdfCandidateFile = (jobId, files) => async (dispatch) => {
  try {
    const formData = new FormData();

    files.forEach((file) => {
      formData.append("files", file);
    });

    const response = await postJobApiCall(
      `jobs/${jobId}/job-candidates/upload-resumes`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    if (response?.status === 200) {
      dispatch({ type: UPLOAD_CANDIDATES_SUCCESS, payload: response.data.message });
      return { success: true, message: response.data.message, data: response.data.data };
    } else {
      const message = response?.data?.detail || response?.data?.message || "Resume upload failed";
      return { success: false, message };
    }
  } catch (error) {
    handle403Logout(error);
    const message =
      error?.response?.data?.detail ||
      error?.response?.data?.message ||
      error?.message ||
      "Resume upload failed";
    return { success: false, message };
  }
};




//candidate profile
export const fetchCandidateProfile = (jobId, candidateId) => async (dispatch) => {
  dispatch({ type: CANDIDATE_LOADING, payload: true });
  try {
    const response = await getJobApiCall(`jobs/${jobId}/job-candidates/${candidateId}`);
    if (response?.status === 200) {
      dispatch({ type: GET_CANDIDATE_PROFILE_SUCCESS, payload: response.data.data });
      return { success: true, data: response.data.data };
    } else {
      dispatch({ type: CANDIDATE_LOADING, payload: false });
      returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    dispatch({ type: CANDIDATE_LOADING, payload: false });
    returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
  }
};

// Upload single candidate Resume
export const uploadSingleCandidateResume = (jobId, candidateId, file) => async (dispatch) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await postJobApiCall(
      `jobs/${jobId}/job-candidates/${candidateId}/upload-resume`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    if (response?.status === 200) {
      dispatch(fetchCandidatesByJobId(jobId));
      return { success: true, message: response.data.message };
    } else {
      const message = response?.data?.detail || response?.data?.message || "Upload failed.";
      return { success: false, message };
    }
  } catch (err) {
    handle403Logout(err);
    const message =
      err?.response?.data?.detail ||
      err?.response?.data?.message ||
      err?.message ||
      "Something went wrong during upload.";
    return { success: false, message };
  }
};


//delete candidate record
export const deleteCandidate = (jobId, candidateId) => async (dispatch) => {
  try {
    const response = await deleteJobApiCall(`jobs/${jobId}/job-candidates/${candidateId}`);
    if (response?.status === 200) {
      dispatch(fetchCandidatesByJobId(jobId));
      return { success: true, message: response.data.message };
    } else {
      returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
  }
};

// Initiate voice call
export const initiateVoiceCall = (jobId, candidateId, assistantId) => async (dispatch) => {
  try {
    const body = { assistant_id: assistantId };
    const response = await postJobApiCall(`jobs/${jobId}/voice-call/initiate/${candidateId}`, body);
    if (response?.status === 200) {
      return { success: true, message: response.data.message };
    } else {
      returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
  }
};


export const fetchVoiceCallSession = (voiceCallId) => async (dispatch) => {
  try {
    const response = await getJobApiCall(`voice-call-session/${voiceCallId}`);
    if (response?.status === 200) {
      dispatch({ type: SET_VOICE_SESSION_DATA, payload: response.data.data });
      return { success: true, data: response.data.data };
    } else {
      returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
  }
};

//update candidate details
export const updateCandidateDetails = (jobId, candidateId, payload) => async (dispatch) => {
  try {
    const response = await putJobApiCall(`jobs/${jobId}/job-candidates/${candidateId}`, payload);
    if (response?.status === 200) {
      return { success: true, message: response.data.message };
    } else {
      returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
  }
};

//getting voice assistants
export const fetchVoiceAssistants = (languageId = "") => async (dispatch) => {
  try {
    let url = "voice-assistants";
    if (languageId) {
      url += `?language_id=${languageId}`;
    }
    const response = await getJobApiCall(url);
    if (response?.status === 200) {
      return { success: true, data: response.data.data };
    } else {
      returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
  }
};

//sending assessment invite to candidate
export const sendAssessmentInvite = (payload) => async (dispatch) => {
  try {
    const response = await postApiCall('test/send-job-assessment-invite', payload);
    if (response?.status === 200) {
      return { success: true, message: response.data.message };
    } else {
      returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
  }
};


//fetching candidate assessment details
export const fetchAssessmentInviteDetails = (inviteId) => async (dispatch) => {
  try {
    const response = await getApiCall(`candidate/get-invite?inviteId=${inviteId}`);
    if (response?.status === 200) {
      dispatch({ type: SET_ASSESSMENT_INVITE_DETAILS, payload: response.data.invite });
      return { success: true, data: response.data.data };
    } else {
      returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
  }
};

export const clearCandidateList = () => (dispatch) => {
  dispatch({ type: CLEAR_CANDIDATE_LIST });
};

//initiate video call
export const initiateVideoCall = (payload) => async (dispatch) => {
  try {
    const response = await postJobApiCall('video-call/initiate', payload);
    if (response?.status === 200) {
      return { success: true, message: response.data.message };
    } else {
      returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
  }
};

// voice call details
export const fetchVideoCallDetails = (videoCallId) => async (dispatch) => {
  try {
    const response = await getJobApiCall(`video-call/${videoCallId}`);
    if (response?.status === 200) {
      dispatch({ type: SET_VIDEO_SESSION_DATA, payload: response.data.data });
      return { success: true, data: response.data.data };
    } else {
      returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
  }
};

export const clearCandidateSessionData = () => (dispatch) => {
  dispatch({ type: "SET_VOICE_SESSION_DATA", payload: null });
  dispatch({ type: "SET_VIDEO_SESSION_DATA", payload: null });
  dispatch({ type: "SET_ASSESSMENT_INVITE_DETAILS", payload: null });
};

//export candidates as csv
export const exportCandidatesAsCsv = (jobId) => async (dispatch) => {
  try {
    const response = await getJobApiBlobCall(`jobs/${jobId}/job-candidates/export`);
    if (response?.status === 200 && response.data instanceof Blob) {
      return { success: true, blob: response.data };
    } else {
      returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status);
      return { success: false, message: "Export failed or invalid file." };
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    return { success: false, message: "Export failed or invalid file." };
  }
};

// Bulk update hiring status
export const bulkUpdateHiringStatus = (jobId, payload) => async (dispatch) => {
  try {
    const response = await patchJobApiCall(`jobs/${jobId}/job-candidates/bulk-update-hiring-status`, payload);
    if (response?.status === 200) {
      return { success: true, message: response.data.message };
    } else {
      returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    return { success: false, message: error?.response?.data?.message || "Something went wrong" };
  }
};

//candidate pre screening report
export const getPreScreeningReport = (id) => async (dispatch) => {
  try {
    const response = await getJobApiCall(`candidate/${id}/jpq-candidate-report/`);
    if (response?.status === 200) {
      dispatch({ type: GET_PREQUALIFYING_REPORT, payload: response.data.data });
    } else {
      returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
  }
}

// update voice call status
export const getVoiceSessionStatus = (voiceCallId) => async (dispatch) => {
  try {
    const response = await getJobApiCall(`voice-call-session/${voiceCallId}/status`);
    if (response?.status === 200) {
      dispatch({ type: SET_VOICE_SESSION_DATA, payload: response.data.data });
      return { success: true, data: response.data.data };
    } else {
      returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
  }
}

//Create share link
export const createShareLink = (payload) => async (dispatch) => {
  try {
    const response = await postJobApiCall("candidate-report-share/create", payload);
    if (response?.status === 200 || response?.status === 201) {
      return { success: true, data: response.data.data };
    } else {
      returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status);
      return { success: false, message: response?.data?.message };
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    return { success: false, message: error?.response?.data?.message || "Something went wrong" };
  }
};

//send report link in email
export const sendShareEmail = (payload) => async () => {
  try {
    const res = await postJobApiCall("candidate-report-share/share-email", payload);

    if (res?.status === 200) {
      return { success: true, data: res.data };
    }
    return { success: false, message: res.data?.message || "Failed to send invite" };
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.response?.data?.message || "Something went wrong" };
  }
};

//copied shared link validation
export const validateShareLink = (payload) => async () => {
  try {
    const response = await postJobApiCall("candidate-report-share/validate", payload);

    if (response?.status === 200) {
      return { success: true, data: response.data.data };
    }
    return { status: response?.status };
  } catch (error) {
    handle403Logout(error);
    return { status: error?.response?.status };
  }
};

//email shared link validation
export const validateEmailShareLink = (payload) => async () => {
  try {
    const response = await postJobApiCall("candidate-report-share/email/validate", payload);

    if (response?.status === 200) {
      return { success: true, data: response.data.data };
    }
    return { status: response?.status };
  } catch (error) {
    handle403Logout(error);
    return { status: error?.response?.status };
  }
};

export const getListCandidates = (folder_id, list_id, search, limit = 10, page = 1) => async (dispatch) => {
  try {
    let url = `candidates/search-advanced`;
    const body = {
      is_active: true,
      page_size: limit,
      page
    };
    if (search) body.search = search;
    if (folder_id) body.folder_id = folder_id;
    if (list_id) body.list_id = list_id;

    const response = await postJobApiCall(url, body);
    if (response?.status === 200) {
      dispatch({ type: GET_LIST_CANDIDATES_SUCCESS, payload: response.data.data || [] });
      return { success: true, data: response.data.data, pagination: response.data.pagination };
    } else {
      dispatch({ type: GET_LIST_CANDIDATES_SUCCESS, payload: [] });
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    dispatch({ type: GET_LIST_CANDIDATES_SUCCESS, payload: [] });
    returnErrors(dispatch, error.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
  }
};

export const clearListCandidates = () => (dispatch) => {
  dispatch({ type: CLEAR_LIST_CANDIDATES });
};

// Get folders by company_id
export const getFolders = (company_id) => async (dispatch) => {
  try {
    const response = await getJobApiCall(`folders`);
    if (response?.status === 200) {
      return { success: true, data: response.data.data || response.data };
    } else {
      return { success: false };
    }
  } catch (error) {
    handle403Logout(error);
    return { success: false };
  }
};

// Get lists by folder_id (and name as query param)
export const getListsByFolder = (folder_id, name) => async (dispatch) => {
  try {
    let url = 'lists';
    const params = [];
    params.push(`page_size=${1000}`)
    if (folder_id) params.push(`folder_id=${folder_id}`);
    if (name) params.push(`name=${name}`);
    if (params.length) url += `?${params.join('&')}`;

    const response = await getJobApiCall(url);
    if (response?.status === 200) {
      return { success: true, data: response.data.data || response.data };
    } else {
      return { success: false };
    }
  } catch (error) {
    handle403Logout(error);
    return { success: false };
  }
};

// Create a new folder
export const createFolder = (body) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`folders/`, body);
    if (response?.status === 200 || response?.status === 201) {
      return { success: true, data: response.data.data || response.data };
    } else {
      const message = response?.data?.detail || response?.data?.message || 'Folder creation failed';
      return { success: false, message, status: response?.status };
    }
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.response?.data?.message || 'Folder creation failed', status: error?.response?.status };
  }
};

// Create a new list
export const createList = (body) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`lists`, body);
    if (response?.status === 200 || response?.status === 201) {
      return { success: true, data: response.data.data || response.data };
    } else {
      const message = response?.data?.detail || response?.data?.message || 'List creation failed';
      return { success: false, message, status: response?.status };
    }
  } catch (error) {
    handle403Logout(error);
    return { success: false, message: error?.response?.data?.message || 'List creation failed', status: error?.response?.status };
  }
};

// Dump candidates into a list
export const dumpCandidatesToList = (list_id, candidate_ids) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`lists/${list_id}/candidates/dump`, { candidate_ids });
    if (response?.status === 200 || response?.status === 201) {
      return { success: true, message: response.data?.message || 'Candidates moved successfully' };
    } else {
      const message = response?.data?.detail || response?.data?.message || 'Move failed';
      return { success: false, message };
    }
  } catch (error) {
    handle403Logout(error);
    const message =
      error?.response?.data?.detail ||
      error?.response?.data?.message ||
      error?.message ||
      'Move failed';
    return { success: false, message };
  }
};

// Agent query - smart search
export const agentQuery = (query) => async (dispatch) => {
  try {
    const response = await postJobApiCall('agent/query', { query });
    if (response?.status === 200) {
      return { success: true, data: response.data };
    } else {
      const message = response?.data?.detail || response?.data?.message || 'Query failed';
      return { success: false, message };
    }
  } catch (error) {
    handle403Logout(error);
    const message =
      error?.response?.data?.detail ||
      error?.response?.data?.message ||
      error?.message ||
      'Query failed';
    return { success: false, message };
  }
};

// Search advanced with raw payload (used for infinite scroll after agent/query)
export const searchAdvancedWithPayload = (payload) => async (dispatch) => {
  try {
    const response = await postJobApiCall('candidates/search-advanced', payload);
    if (response?.status === 200) {
      return { success: true, data: response.data.data || [], pagination: response.data.pagination };
    } else {
      return { success: false };
    }
  } catch (error) {
    handle403Logout(error);
    return { success: false };
  }
};

// Upload candidate resumes (with company_id, folder_id, list_id as query params)
export const uploadCandidateResumes = (folder_id, list_id, files) => async (dispatch) => {
  try {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('files', file);
    });

    const response = await postJobApiCall(
      `candidates/upload-resumes?folder_id=${folder_id}&list_id=${list_id}`,
      formData
    );

    if (response?.status === 200 || response?.status === 201) {
      return { success: true, message: response.data.message || 'Uploaded successfully' };
    } else {
      const message = response?.data?.detail || response?.data?.message || 'Upload failed';
      return { success: false, message };
    }
  } catch (error) {
    handle403Logout(error);
    const message =
      error?.response?.data?.detail ||
      error?.response?.data?.message ||
      error?.message ||
      'Upload failed';
    return { success: false, message };
  }
};

export const uploadResumeStatus = (jobId) => async (dispatch) => {
  try {
    const response = await getJobApiCall(`resume-upload?job_id=${jobId}`);
    if (response?.status === 200) {
      return { success: true, data: response.data.data };
    } else {
      const message = response?.data?.detail || response?.data?.message || 'Upload failed';
      return { success: false, message };
    }
  } catch (error) {
    handle403Logout(error);
    const message = error?.response?.data?.detail || error?.response?.data?.message || error?.message || 'Upload failed';
    return { success: false, message };
  }
}